
import { copyToClip } from '~/utils/index.js'
import TitleBox from '@/components/CSS/TitleBox'
import { openServiceAuth } from '@/settings'
import { mapGetters } from 'vuex'

export default {
	components: {
		TitleBox
	},
	data() {
		return {
			serviceData: [],
			activeName: 'first',
			qrCodeData: '',
			isShow: false
		}
	},

	computed: {
		...mapGetters({ userinfo: 'user/userinfo', token: 'user/token' })
	},
	methods: {
		back() {
			window.history.go(-1)
		},
		copySuccess(val) {
			copyToClip(val, '已复制')
		},
		join() {
			if (openServiceAuth && !this.token) {
				this.$message.warning('请先登录')
				this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
				return
			}
			let e = null
			// 调用接口获取客服数据
			this.$api.findIm().then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				} else {
					e = res.data
					console.log(e.staffId)
					if (e.staffId) {
						this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
						this.$store.dispatch('ry/join', { targetId: e.staffId, conversationType: 1 })
						this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
						this.$store.commit('ry/SET_ORDER_FLOW', [])
					}
				}
			})
		},
		getCustomer() {
			this.$api.feed().then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.serviceData = res.data
			})
		},
		handleClick(tab, event) {
			console.log(tab, event)
		},
		crateQrcode() {
			this.qrCodeData = `${process.env.ENV_H5_URL}/center/complaint`
			this.isShow = true
		}
	},
	created() {
		this.getCustomer()
		this.$nextTick(() => {
			this.crateQrcode()
		})
	}
}
